import gql from 'graphql-tag';

export const getEventsByStudentBK = gql`
  query getEventsByType($eventType: String!) {
    eventsReservation {
      eventsType(parameters: { eventType: $eventType }) {
        events {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventSubtype {
            id
            name
          }
          eventType {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isFeatured
          isToday
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
        }
        featured {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isFeatured
          isToday
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
        }
      }
    }
  }
`;

export const getEventsByStudent = gql`
  query getEventsByType($eventType: String!) {
    eventsReservation {
      eventsType(parameters: { eventType: $eventType }) {
        events {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isToday
          isFeatured
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
          scheduleDetail {
            idDay
            startTime
            endTime
            date
          }
          isRescheduled
          isCanceled
        }
        featured {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isToday
          isFeatured
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
          scheduleDetail {
            idDay
            startTime
            endTime
            date
          }
          isRescheduled
          isCanceled
        }
      }
    }
  }
`;

export const getEventDetail = gql`
  query getEventByIdPortal(
    $eventId: Float!
    $campus: String!
    $modality: String!
  ) {
    eventsReservation {
      eventByIdPortal(
        parameters: { eventId: $eventId, campus: $campus, modality: $modality }
      ) {
        idEvent
        name
        eventImage
        startDate
        endDate
        eventType {
          id
          name
        }
        eventSubtype {
          id
          name
        }
        modality
        isOnly
        isSubscribed
        isToday
        isFeatured
        isVariedSchedule
        teacher
        vacancies
        schedule {
          idDay
          startTime
          endTime
        }
        scheduleDetail {
          idDay
          date
          startTime
          endTime
        }
        organizer {
          id
          name
        }
        description
        link
        linkMeet
        classroom
        flat
        campus
        address
        isRescheduled
        isExist
        isAccessible
        totalWeeks
        totalSessions
        sessionsWeek
        linkInformation
        linkInformationDes
        canUnsubscribe
        statusWaitingList
      }
    }
  }
`;

export const setEventInscription = gql`
  mutation subscribeEvent($eventId: Float!) {
    subscribeEvent(parameters: { eventId: $eventId }) {
      status
      data
      message
    }
  }
`;

export const setEventUnSubscribe = gql`
  mutation unSubscribeEvent($eventId: Float!) {
    unSubscribeEvent(parameters: { eventId: $eventId }) {
      status
      data
      message
    }
  }
`;

export const getEventsByTypeScroll = gql`
  query getEventsByScrollType(
    $eventType: String!
    $page: Float!
    $career: String!
    $campus: String!
  ) {
    eventsReservation {
      eventsScrollType(
        parameters: {
          eventType: $eventType
          page: $page
          career: $career
          campus: $campus
        }
      ) {
        events {
          idEvent
          name
          vacancies
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isToday
          isFeatured
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
          scheduleDetail {
            idDay
            startTime
            endTime
            date
          }
          isRescheduled
          isCanceled
        }
        featured {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          vacancies
          isToday
          isFeatured
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
          scheduleDetail {
            idDay
            startTime
            endTime
            date
          }
          isRescheduled
          isCanceled
        }
        eventsWaitingList {
          idEvent
          name
          eventImage
          startDate
          endDate
          eventType {
            id
            name
          }
          eventSubtype {
            id
            name
          }
          modality
          isOnly
          isSubscribed
          isFeatured
          isToday
          isVariedSchedule
          schedule {
            idDay
            startTime
            endTime
          }
          statusWaitingList
        }
      }
    }
  }
`;

export const getPenalties = gql`
  query getPenalties($period: String!) {
    eventsReservation {
      penalties(period: $period)
    }
  }
`;

export const subscribeToWaitingList = gql`
  mutation subscribeToWaitingList($eventId: Float!, $periodId: String) {
    subscribeToWaitingList(
      parameters: { eventId: $eventId, periodId: $periodId }
    ) {
      status
      data
      message
    }
  }
`;

export const unsubscribeToWaitingList = gql`
  mutation unsubscribeToWaitingList($eventId: Float!) {
    unsubscribeToWaitingList(parameters: { eventId: $eventId }) {
      status
      data
      message
    }
  }
`;

export const getOrganizer = gql`
  query getOrganizer {
    eventsReservation {
      organizer {
        id
        name
      }
    }
  }
`;
